interface ITopOverlayProps {
  children: React.ReactNode;
}

const TopOverlay: React.FC<ITopOverlayProps> = ({ children }) => {
  return <div className="absolute top-0 left-0 w-full z-50">{children}</div>;
};

export default TopOverlay;
